import React from "react";
import ClientAccordion from "./ClientAccordion";
import ProductTitle from "./ProductTitle";
import RCPROBlocks from "./RCPROBlocks";

const RCPROContainer = ({ RCPROClients }) => {
  return (
    <div className="mb-5">
      <ProductTitle
        icon="umbrella"
        title="Demande de Responsabilité Civile Pro"
      />
      <div className="mt-3">
        <p>
          <strong>
            Nous étudions votre demande de Responsabilité Civile Pro
          </strong>{" "}
          à partir des informations que vous avez renseigné. Nous revenons vers
          vous au plus vite.
        </p>
      </div>
      {RCPROClients.map((client) => {
        console.log("client", client);
        return (
          <ClientAccordion client={client}>
            {client.establishments.map((company) => (
              <RCPROBlocks
                company={company}
                clientId={client.clientId}
                key={`compac${company.name}`}
              />
            ))}
          </ClientAccordion>
        );
      })}
    </div>
  );
};

export default RCPROContainer;
